import { FormGroup, Validators } from '@angular/forms';
import { Numbers } from 'src/app/utils/constants';

export default class LegalStepTwoComponentUtilsExtended {

    /**
     * constructor
     */
    constructor(
      ) {
    }

    public disabledFormR = true;
    public showRentedHouse = false;
    public disabledEmpApe1 = false;
    public disabledEmpApe2 = false;
    public formDataValue: any;
    public munichange: { name: string, value: any };
    public provchange: { name: string, value: any };
    public cpchange: { name: string, value: any };
    public showModal = false;
    public displayModal: boolean;
    public disabledMuniL1 = true;
    public munichange2: { name: string, value: any };
    public countrychange2: { name: string, value: any };
    public countrychange: { name: string, value: any };
    public provchange2: { name: string, value: any };
    public cpchange2: { name: string, value: any };
    public formDataUtilsExtended: FormGroup;
    public muniRecived: any;
    public prefixchanged: { name: string, value: any};
    public showNoRequiredSurname = 'legal.bussiness.first-surname.no-req';
    public showLegalCompany = false;
    public typeChange: { name: string, value: any };
    public showRentedHousCheck = false;

    /**
     * initLegalParticularUtilsExtended
     * @param formData formData
     * @param el el
     * @param formConfig formConfig
     * @param patternCP patternCP
     */
    initLegalParticularUtilsExtended(formData: FormGroup, el: any, formConfig: any, patternCP: any): void {
        this.formDataUtilsExtended = formData;
        this.showRentedHouse = false;
        if (el) { this.showRentedHouse = true; }
        if (!el && this.formDataUtilsExtended.valid) {
            this.disabledFormR = false;
        } else if (!el && this.formDataUtilsExtended.invalid) {
            this.disabledFormR = true;
        } else {
            this.disabledFormR = false;
        }
        if (this.showRentedHouse) {
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.direction.linkFormPath).setValidators([Validators.required]);
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.postalCode.linkFormPath)
            .setValidators([Validators.pattern(patternCP), Validators.required]);
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.municipality.linkFormPath).setValidators([Validators.required]);
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.province.linkFormPath).setValidators([Validators.required]);
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.country.linkFormPath).setValidators([Validators.required]);
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.direction.linkFormPath).updateValueAndValidity();
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.postalCode.linkFormPath).updateValueAndValidity();
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.municipality.linkFormPath).updateValueAndValidity();
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.province.linkFormPath).updateValueAndValidity();
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.country.linkFormPath).updateValueAndValidity();
        } else {
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.direction.linkFormPath).clearValidators();
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.postalCode.linkFormPath).clearValidators();
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.municipality.linkFormPath).clearValidators();
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.province.linkFormPath).clearValidators();
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.country.linkFormPath).clearValidators();
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.direction.linkFormPath).updateValueAndValidity();
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.postalCode.linkFormPath).updateValueAndValidity();
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.municipality.linkFormPath).updateValueAndValidity();
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.province.linkFormPath).updateValueAndValidity();
            this.formDataUtilsExtended.get(formConfig.rentedHouseData.country.linkFormPath).updateValueAndValidity();
        }
    }

    /**
     * getProductChoosedUtilsExtended
     * @param formData formData
     * @param insureSelected insureSelected
     * @param formConfig formConfig
     */
    getProductChoosedUtilsExtended(formData: FormGroup, insureSelected: string, formConfig: any): void {
        if (formData) {
          this.formDataValue = formData.get(insureSelected).value;
          const auxCIFDoc: any = formData.get(formConfig.documentType.linkFormPath).value;
          if (auxCIFDoc !== '' && auxCIFDoc.name === 'CIF') {
            this.disabledEmpApe1 = true;
            this.disabledEmpApe2 = true;
          }
        }
    }

    /**
     * checkEnableCompanyUtilsExtended
     * @param formData formData
     * @param formConfig formConfig
     * @param chooseOne chooseOne
     */
    checkEnableCompanyUtilsExtended(formData: any, formConfig: any, chooseOne: any): void {
        const auxValue: any = formData.get(formConfig.documentType.linkFormPath).value;
        const auxChoosed: any = chooseOne;
        if (auxValue.name === 'CIF' && auxChoosed === 'Empresa') {
          this.disabledEmpApe1 = true;
          this.disabledEmpApe2 = true;
        }
    }

    /**
     * changeCountryUtilsExtended
     * @param municipality municipality
     * @param formData formData
     * @param insureSelected insureSelected
     */
    changeCountryUtilsExtended(municipality: any, formData: FormGroup, insureSelected: string): void {
      this.formDataUtilsExtended = formData;
      if (municipality !== null) {
            this.munichange = { name: 'municipio', value: municipality[0] };
            this.provchange = { name: 'provincia', value: '0' };
            this.cpchange = { name: 'cp', value: '0' };
            this.formDataUtilsExtended.get([insureSelected, 'insuredData', 'postalCode']).setValue(0);
        } else {
            this.munichange = { name: 'municipio', value: 'error' };
            this.provchange = { name: 'provincia', value: 'error' };
            this.cpchange = { name: 'cp', value: 'error' };
            this.showModalDialog();
        }
    }

    /**
     * showModalDialog
     */
    showModalDialog(): void {
        this.displayModal = true;
        this.showModal = this.displayModal;
    }

    /**
     * getMunicipalityUtilsExtended
     * @param municipality municipality
     * @param field field
     * @param auxRented auxRented
     * @param insureSelected insureSelected
     * @param formData formData
     * @param idMunicipioRecuperado idMunicipioRecuperado
     */
    getMunicipalityUtilsExtended(municipality: any, field: any, auxRented: string, insureSelected: string,
                                 formData: FormGroup, idMunicipioRecuperado: string): void {
                                   this.formDataUtilsExtended = formData;
                                   if (municipality !== null && municipality.length > 1) {
          this.changeMunicipality(municipality, idMunicipioRecuperado, field, auxRented);
        } else if (municipality !== null && municipality.length <= 1) {
          this.changeMunicipality2(municipality, insureSelected, field, auxRented);
        } else {
          this.changeCp(insureSelected, field, auxRented);
          this.showModalDialog();
        }
    }

    /**
     * changeMunicipality
     * @param municipality any
     * @param idMunicipioRecuperado any
     * @param field any
     * @param auxRented any
     */
    changeMunicipality(municipality: any, idMunicipioRecuperado: any, field: any, auxRented: any): void {
        if (idMunicipioRecuperado !== '') {
            municipality.forEach(item => {
            if (item.Id_Municipio === idMunicipioRecuperado) {
                this.muniRecived = item;
            }
            });
            this.munichange = { name: 'municipio', value: this.muniRecived };
            this.provchange = { name: 'provincia', value: this.muniRecived.Des_Provincia };
            this.countrychange = { name: 'country', value: 'España' };
        } else {
            this.disabledMuniL1 = false;
            if (field !== undefined && field.includes(auxRented)) {
                this.munichange2 = { name: 'municipio-list', value: municipality };
                this.countrychange2 = { name: 'country', value: 'España' };
            } else {
                this.munichange = { name: 'municipio-list', value: municipality };
                this.countrychange = { name: 'country', value: 'España' };
            }
        }
    }

    /**
     * changeMunicipality2
     * @param municipality any
     * @param insureSelected string
     * @param field any
     * @param auxRented any
     */
    changeMunicipality2(municipality: any, insureSelected: string, field: any, auxRented: any): void {
        if (insureSelected === 'ownerLegalAsistance') {
            this.formDataUtilsExtended.get([insureSelected, 'insuredData', 'provinceId']).setValue(municipality[0].Id_Provincia);
        }
        if (field !== undefined && field.includes(auxRented)) {
            this.munichange2 = { name: 'municipio', value: municipality[0] };
            this.provchange2 = { name: 'provincia', value: municipality[0].Des_Provincia };
            this.countrychange2 = { name: 'country', value: 'España' };
            this.formDataUtilsExtended.get([insureSelected, 'insuredData', 'rentedHouseData', 'provinceId'])
                .setValue(municipality[0].Id_Provincia);
        } else {
            this.munichange = { name: 'municipio', value: municipality[0] };
            this.provchange = { name: 'provincia', value: municipality[0].Des_Provincia };
            this.countrychange = { name: 'country', value: 'España' };
        }
    }

    /**
     * changeCp
     * @param insureSelected string
     * @param field any
     * @param auxRented any
     */
    changeCp(insureSelected: string, field: any, auxRented: any): void {
        if (insureSelected === 'ownerLegalAsistance') {
            this.formDataUtilsExtended.get([insureSelected, 'insuredData', 'provinceId']).setValue(0);
        }
        if (field !== undefined && field.includes(auxRented)) {
            this.cpchange2 = { name: 'cp', value: 'error' };
        } else {
            this.cpchange = { name: 'cp', value: 'error' };
        }
    }

    /**
     * changeMuniUtils
     * @param lista any
     * @param event any
     */
    changeMuniUtils(lista: any, event: any): void {
        if (lista) {
            this.disabledMuniL1 = true;
            this.provchange2 = { name: 'provincia', value: event.Des_Provincia };
            this.countrychange2 = { name: 'country', value: 'España' };
        } else {
            this.provchange = { name: 'provincia', value: event.Des_Provincia };
            this.countrychange = { name: 'country', value: 'España' };
        }
    }

    /**
     * getPrefixChanged
     * @param particularLegalAsistance any
     * @param ownerLegalAsistance any
     * @param form FormGroup
     */
    getPrefixChanged(particularLegalAsistance: any, ownerLegalAsistance: any, form: FormGroup): void {
        let formData: any;
        if (particularLegalAsistance) {
          formData = form.value.particularLegalAsistance;
        } else {
          if (ownerLegalAsistance) {
            formData = form.value.ownerLegalAsistance;
          }
        }

        if (formData.insuredData.prefix.id === '+34' || formData.insuredData.prefix === 'España (+34)') {
            // this.formConfig.telephone.maxlength = '9';
            this.prefixchanged = { name: 'prefix', value: '9' };
          } else {
            // this.formConfig.telephone.maxlength = '13';
            this.prefixchanged = { name: 'prefix', value: '13' };
          }
    }

    /**
     * changeBooleans
     * @param option boolean
     */
    changeBooleans(option: boolean): void {
        this.showLegalCompany = option;
        this.disabledEmpApe1 = option;
        this.disabledEmpApe2 = option;
    }

    /**
     * checkShowRentedHouse
     * @param priority number
     * @param linkFormPath boolean
     */
    checkShowRentedHouse(priority: number, linkFormPath: boolean): void {
        this.showRentedHousCheck = false;
        if (priority === 1) {
          this.showRentedHousCheck = true;
        }
        if (this.showRentedHousCheck) {
          this.showRentedHouse = linkFormPath;
        }
    }

    /**
     * keyValueControl
     * @param keyValueControl string
     * @param postalCode any
     */
    keyValueControl(keyValueControl: string, postalCode: any): void {
        if (keyValueControl === 'check-document') {
            // this.checkDocumentBlur(keyValueName);
        } else {
            if (this.formDataValue.countryOriginEnvironment === Numbers.number19001 &&
                (postalCode === 0 || postalCode === '0')) {
              this.cpchange = { name: 'cp', value: 'error-spain' };
            }
            if (postalCode === '') {
              this.cpchange = { name: 'cp', value: 'error-empty' };
            }
        }
    }
}
